var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.token!=null)?_c('div',[_c('TopToolbar'),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }